import * as profilePicTypes from '../types/profilePicTypes'
export const applyProfilePic  = (photo) => (dispatch) => {
    localStorage.setItem("profilePic", JSON.stringify(photo));
    dispatch({
        type: profilePicTypes.APPLY_PROFILE_PIC,
        payload: photo
    });
};